<template>
  <div class="full-topics">
    <div ref="graph" class="graph-content"></div>
    <div class="black" @click="goBlack" :class="{'black-class':fullClass}">{{$t('exitTheFullScreen')}}</div>
<!--    <div class="fill-topics-type" @click="changeType" v-if="isGraph===1">切换{{$route.params.type==='expert'-->
<!--      ?'普通探索':'高级探索'}}-->
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import {mapGetters} from 'vuex'
import $ from 'jquery'


const lang = localStorage.getItem('locale')
import schema_cn_const from './analysis/schema_cn.json'
import schema_en_const from './analysis/schema_en.json'

export default {
  name: 'FullTopics',
  data () {
    return {
      graph: null,
      fullClass: false,
      settings: {
        ajaxSettings: {
          // baseUrl: config.baseUrl + '/country/dz/',
          // baseUrl: config.baseUrl + '/forward/sdk/',
          headers: {
            // APK: '37df4b42bf6442ae8dd263c731dccb6b'
          },
          // queryData: {
          //   p: 'spa_pc_graph'
          // },
          // beforeLoad: (data) => {
          //   console.log(data)
          //   // debugger
          //   return data
          // }
        },
        // schema:{
        //   "types":[{k:1,v:'国家',parentId: 0},{k:2,v:'城市',parentId: 0},{k:3,v:'行业',parentId: 0},{k:4,v:'项目',parentId: 0},{k:5,v:'企业',parentId: 0},{k:6,v:'执行机构',parentId: 0}],
        //   "atts":[{k:7, v:'关联国家',domain:1},{k:8, v:'关联行业',domain:3},{k:9, v:'关联项目',domain:4},{k:10, v:'关联企业',domain:5},{k:11, v:'执行结构',domain:6}],
        //   "attGroup": [],
        //   "kgTitle": "pbr图谱"
        // },
        schema:lang === 'en' ? schema_en_const.data : schema_cn_const.data,
        showLinkInfoOnClick: true,
        'attValueRule': {
          'enable': false,
          'settings': {
            'box': {
              'isOpen': false
            }
          }
        },
        contextmenu: {
          enable: true,
          settings: {
            menu: {
              'jump': {
                'enable': false,
                'settings': {
                  'children': [
                    {
                      'type': 'graph'
                    },
                    {
                      'type': 'path'
                    },
                    {
                      'type': 'relation'
                    },
                    {
                      'type': 'timing'
                    },
                    {
                      'type': 'explore'
                    }
                  ]
                }
              },
              'business-rule': {
                'enable': false
              },
              'sub-graph': {
                enable: false
              },
              'analysis-path': {
                enable: true
              },
              'analysis-relation': {
                enable: true
              },
              'node-explore': {
                enable: true
              },
              'node-explore-next': {
                enable: true
              },
              'node-explore-previous': {
                enable: true
              },
              jumpSearch: {
                settings: {
                  title: '跳转至搜索页',
                  click: (a, b, c) => {
                    this.PdJumpSearch()
                  },
                  customEnable: (data) => {
                    window.clickpdNode = data
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && !(isNodes.classIdList.indexOf(13) !== -1 || isNodes.classIdList.indexOf(5) !== -1)
                  }
                }
              },
              jumpSearchDetail: {
                settings: {
                  title: '跳转至详情页',
                  click: (a, b, c) => {
                    this.PdJumpSearch()
                  },
                  customEnable: (data) => {
                    window.clickpdNode = data
                    const isNodes = data.nodes && data.nodes.length && data.nodes[0]
                    return isNodes && (isNodes.classIdList.indexOf(13) !== -1 || isNodes.classIdList.indexOf(5) !== -1)
                  }
                }
              }
            },
            items: [
              'jumpSearchDetail',
              'jumpSearch',
              'business-rule',
              'layout',
              'node-focus-to',
              'node-explore',
              'analysis-relation',
              'analysis-path',
              'node-explore-previous',
              'node-explore-next',
              'jump',
              'align',
              'node-hide',
              'node-show',
              'sub-graph',
              'node-editor',
              'node-style',
              'link-editor',
              'link-style',
              'other',
              'clear',
              'common-config'
            ]
          }
        },
        infoboxSettings: {
          settings: {
            ajaxSettings: {
              formData: {
                isRelationAtts: false
              }
            }
          }
        },
        // kgName: 'plantdata_bj73pdk7_graph_17332e734da',
        // kgName: 'a_sl_znsj_bj73pb34_graph_1754bffd7e0',
        netChartSettings: {
          rightPanel: {
            mode: 'fixed',
            active: false
          },
          main: {
            layout: 'static',
            events: {
              onClick: (event, arg) => {
                this.$emit('changeGraph', event, arg)
              },
              onDoubleClick: (event, arg) => {
                this.$emit('doubleClick', arg.clickItem)
              }
            }
          }
        },
        nodeLegend: {
          enable: true
        },
        linkLegend: {
          settings: {
            color: [
              '#7bc0e1',
              '#9ec683',
              '#fde14d',
              '#ab89f4',
              '#FAC9B8',
              '#dca8c6',
              '#596690',
              '#eaad84',
              '#abe8bf',
              '#7979fc',
              '#FF6F5E',
              '#FFAF5E',
              '#D4B311',
              '#B4D411',
              '#73D411',
              '#11D4B3',
              '#11B3D4',
              '#1152D4',
              '#9311D4'
            ]
          }
        },
        pluginsSettings: {
          settings: {
            size: 'sm'
          }
        },
        promptSettings: {
          ajaxSettings: {
            queryData: {
              isInherit: true,
              openExportDate: true,
              allowTypes: '[37,20,6,34,26,9,16]'
            }
          }
        },
        showAllSchemaOptions: true,
        timeChart: {
          settings: {
            settings: {
              color: [
                '#5677fc'
              ],
              dataZoom: [
                {
                  fillerColor: 'rgba(57, 141, 238, .3)'
                }
              ]
            },
            dialogSettings: {
              defaultTimeFilterSettings: {
                1: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: false,
                  noTimeNodes: true
                },
                2: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: true,
                  fixedNodes: true,
                  noTimeLinks: true,
                  noTimeNodes: true
                }
              },
              defaultTimeFilterType: '2',
              rule: {
                1: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                2: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                },
                3: {
                  fixedLinks: false,
                  fixedNodes: false,
                  noTimeLinks: false,
                  noTimeNodes: false
                }
              }
            }
          }
        },
        snapshot: {
          enable: false
        },
        selector: '.graph-content',
        loaderSettings: {
          ajaxSettings: {
            formData: {
              isInherit: true,
              hyponymyDistance: 0
            }
          }
        },
        page: {
          enable: false,
          settings: {
            side: 'top'
          }
        },
        toolbar: {
          enable: true,
          settings: {
            menu: {
              fullscreen: {
                enable: false
              },
              export: {
                enable: false
              },
              dragSelect: {
                enable: false
              },
              hoverHighlight: {
                enable: false
              },
              overview: {
                enable: false
              }
            }
            // items: ['back']
          }
        },
        changeLayout: {
          enable: true,
          setting: {
            layout: 'static' // 未知为啥没有s
          },
          settings: {
            sankey: false
          }
        },
        find: {
          enable: false
        },
        history: {
          enable: true
        },
        wordCloudView: {
          enable: false
        },
        relativeFiles: {
          enable: false
        },
        visConfigure: {
          enable: false
        },
        filter: {
          enable: true,
          settings: {
            editItemSettings: [
              {
                key: 'isRelationMerge',
                label: '关系展示合并',
                value: 'true',
                options: [
                  {
                    label: '合并',
                    value: 'true'
                  },
                  {
                    label: '不合并',
                    value: 'false'
                  }
                ]
              },
              {
                key: 'hyponymyDistance',
                disabled: true
              },
              {
                key: 'distance',
                disabled: true,
                options: [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6
                ],
                value: 1
              },
              {
                key: 'allowTypes',
                index: 1
              },
              {
                key: 'allowAtts',
                index: 1
              },
              {
                key: 'distance-expend',
                index: 2,
                value: 1
              }
            ]
          }
        },
        prompt: {
          enable: false,
          settings: {
            side: 'left',
            promptSettings: {
              autocompleteSettings: {
                keyword: false
              }
            }
          }
        },
        infobox: {
          enable: false,
          settings: {
            active: true
          }
        },
        resetLayout: {
          enable: true,
          settings:{
            style:{
              // width:'200px'
            }
          }
        },
        wordCloud: {
          enable: false
        },
        advancedPrompt: {
          enable: false
        },
        tagView: {
          enable: false
        },
        zoomSlider: {
          enable: true
        }
      },
      notify: null
    }
  },
  mounted () {
    // this.init()
  },
  activated () {
    this.init()
  },
  deactivated () {
    $('.pdvis-page-pagesize-dialog') && $('.pdvis-page-pagesize-dialog').remove()
    $('.pdsdk-filter-edge-dialog') && $('.pdsdk-filter-edge-dialog').remove()
  },
  beforeDestroy () {
    this.notify.close()
    $('.pdvis-page-pagesize-dialog') && $('.pdvis-page-pagesize-dialog').remove()
    $('.pdsdk-filter-edge-dialog') && $('.pdsdk-filter-edge-dialog').remove()
  },
  computed: {
    ...mapGetters(['isGraph'])
  },
  methods: {
    init () {
      // !window.allToken && getToken()
      let that = this
      this.settings.ajaxSettings.headers['api-token'] = window.allToken
      try {
        const isExpert = this.$route.params.type === 'expert'
        if (isExpert) {
          _.forEach(this.settings.filter.settings.editItemSettings, (item) => {
            item.key === 'allowTypes' && (item.value = [12, 20, 9, 6, 5, 37, 34, 26, 23, 16, 18, 31, 33, 42, 36,
              29])
          })
        }
        this.graph = isExpert ? new PdSDKDcGraphConcept(this.settings)
          : new PdSDKDcGraph(this.settings)
        this.graph.on('inited', () => {
          isExpert && (this.graph.settings.loaderSettings.ajaxSettings.formData.replaceClassIds =
            this.graph.schema.types.map(t => t.k))
          const query = this.$route.query
          const node = JSON.parse(localStorage.getItem('graphNode'))

          if (query && query.params) {
            if (node && node.id.toString() === query.params) {
              if (this.$route.params.type === 'expert') {
                const {name, id, classId, type} = node
                const o = {
                  id: id.toString(),
                  classId: classId.toString(),
                  name,
                  type
                }
                this.graph.expandEntity([o], {$source: 'api'})
              } else {
                // this.graph.load({id: node.id})
                // this.searchNode(node.id)
                //   .then((data) => {
                //     let focus = null
                //     if (data.entityList && data.entityList.length) {
                //       focus = data.entityList[0]
                //     }
                //     this.graph.netChart.addData(data, focus)
                //   })
                let data = that.$route.params.graph
                if (data.entityList && data.entityList.length) {
                  focus = data.entityList[0]
                }
                that.graph.netChart.addData(data, focus)
              }
            }
          } else {
            // this.graph.load()
            let data = that.$route.params.graph
            if (data.entityList && data.entityList.length) {
              focus = data.entityList[0]
            }
            that.graph.netChart.addData(data, focus)
          }

          // this.graph.netChart.sidePanels.right.on('visibleChange', (data) => {
          //   this.fullClass = !this.fullClass
          // })
        })
      } catch (e) {
        setTimeout(() => {
          this.init()
        }, 500)
      }
    },
    goBlack () {
      this.$router.go(-1)
    },
    changeType () {
      const type = this.$route.params.type
      const path = this.$route.fullPath.replace(type, type === 'expert' ? 'common' : 'expert')
      this.$router.replace({path})
      this.init()
    },
    PdJumpSearch () {
      const node = window.clickpdNode
      this.jumpSearch(node)
    }
  }
}
</script>

<style scoped lang="less">
  .graph-content {
    width: 100%;
    height: 100%;
    position: relative;
  }

  /deep/ svg {
    vertical-align: unset;
  }

  .black {
    position: absolute;
    bottom: 42px;
    right: 44px;
    color: #0a75be;
    cursor: pointer;
    font-size: 16px;
    z-index: 99;
    padding: 2px;
    background: #fff;
    border-radius: 2px;
    transform: translateX(2px);
    transition: all .5s cubic-bezier(.25, .8, .25, 1) 0s;
  }

  .black-class {
    transform: translateX(-390px);
  }
</style>

<style lang="less" scoped>
  .fill-topics-type {
    position: absolute;
    top: 15px;
    left: 290px;
    padding: 8px;
    line-height: 26px;
    background: #fff;
    font-size: 14px;
    color: rgba(0, 0, 0, .6);
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);
    cursor: pointer;
    z-index: 1000;
  }
  /deep/ .pdvis-reset-layout-container {
    .pdvis-float-item-head {
      width: 130px;}}
</style>

<style>
  .full-topics-notification {
    left: 178px !important;
  }
</style>
